import React, { Suspense } from 'react';
import { setFieldState } from '../components/google-address';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/google-address'));

export default function (dependencies) {
  const { language } = dependencies;

  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };
  return {
    html,
    config: {
      behaviour: 'text-input',
      customBlur: true,
      // The component falls back to language['address-label'] when rendering, but that never reaches config.label. Set here so the label is sent with the lead data.
      label: language['address-label'],
    },
    validators: [
      function (state, _, __) {
        const { street_number, value, streetNumberMatched, streetNameMatched, zipMatched } = state;

        if (streetNumberMatched && zipMatched && streetNameMatched) {
          setFieldState(state, { show_error: false });
          return false;
        }

        if (!value) {
          setFieldState(state, { show_error: true });
          return language['error-mandatory'];
        } else if (street_number.length <= 0) {
          setFieldState(state, { show_error: true });
          return language['address-missing-street-number'];
        } else {
          setFieldState(state, { show_error: true });
          return false;
        }
      },
    ],
  };
}
